export default function filterList(entity, filter) {
  return {
    type: 'FILTER_LIST',
    payload: { entity, filter },
  };
}
